<template>
  <div class="row m-1 mt-2">
       
        <div class="col-md-12">
            <div class="card">
                <div class="card-body">
                    <div class="container [ pt-5 pb-4 ] [ text-center ]">
                        <h1 class="heading text-primary text-center">
                            <span class="d-block"><font-awesome-icon :icon="['far','check-circle']" size="4x" :class="d-block"></font-awesome-icon></span>
                            Grazie, il contratto è stato inoltrato con successo
                        </h1>
                       

                    </div>

                   
                    <div class="container">
                        <div class="text-center [ pt-4 pb-5 ]">
                            <router-link class="btn btn-sm btn-primary" :to="{name:'route-contract-new'}">
                                <font-awesome-icon icon="plus-circle"></font-awesome-icon> Aggiungi nuovo contratto
                            </router-link>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
</template>

<script>


export default {
  data() {
    return {
      
    };
  },
 computed: {

     cuser() {
      return this.$store.state.user;
    },
  },
  components: {
  
  },
  name: "ContractTy",
  beforeMount() {
   
  },
  methods: {
   
  },
};
</script>
